module.exports = __webpack_public_path__ + "media/images/atak_plugins-a88e82ef56a5074a4a6c703e2d14de43.jpg";